import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axios";
import { ApiKey } from "../../ApiKey/ApiKey";

// const currencies = [
//   {
//     name: "USD",
//     flag: "https://flagcdn.com/us.svg",
//     conversions: {
//       EUR: 0.958,
//       INR: 86.977,
//       AUD: 1.577,
//       JPY: 151.69,
//       CAD: 1.421,
//       CHF: 0.902,
//       NZD: 1.755,
//     },
//   },
//   {
//     name: "EUR",
//     flag: "https://flagcdn.com/eu.svg",
//     conversions: {
//       USD: 1.044,
//       INR: 90.834,
//       AUD: 1.647,
//       JPY: 158.42,
//       CAD: 1.484,
//       CHF: 0.942,
//       NZD: 1.833,
//     },
//   },
//   {
//     name: "INR",
//     flag: "https://flagcdn.com/in.svg",
//     conversions: {
//       USD: 0.011,
//       EUR: 0.011,
//       AUD: 0.018,
//       JPY: 1.744,
//       CAD: 0.016,
//       CHF: 0.01,
//       NZD: 0.02,
//     },
//   },
//   {
//     name: "AUD",
//     flag: "https://flagcdn.com/au.svg",
//     conversions: {
//       USD: 0.634,
//       EUR: 0.607,
//       INR: 55.161,
//       JPY: 96.202,
//       CAD: 0.901,
//       CHF: 0.572,
//       NZD: 1.113,
//     },
//   },
//   {
//     name: "JPY",
//     flag: "https://flagcdn.com/jp.svg",
//     conversions: {
//       USD: 0.0066,
//       EUR: 0.0063,
//       INR: 0.573,
//       AUD: 0.0104,
//       CAD: 0.0094,
//       CHF: 0.006,
//       NZD: 0.011,
//     },
//   },
//   {
//     name: "CAD",
//     flag: "https://flagcdn.com/ca.svg",
//     conversions: {
//       USD: 0.703,
//       EUR: 0.674,
//       INR: 61.298,
//       AUD: 1.11,
//       JPY: 106.34,
//       CHF: 0.641,
//       NZD: 1.235,
//     },
//   },
//   {
//     name: "CHF",
//     flag: "https://flagcdn.com/ch.svg",
//     conversions: {
//       USD: 1.108,
//       EUR: 1.062,
//       INR: 99.586,
//       AUD: 1.748,
//       JPY: 165.98,
//       CAD: 1.56,
//       NZD: 2.126,
//     },
//   },
//   {
//     name: "NZD",
//     flag: "https://flagcdn.com/nz.svg",
//     conversions: {
//       USD: 0.57,
//       EUR: 0.545,
//       INR: 49.657,
//       AUD: 0.899,
//       JPY: 85.98,
//       CAD: 0.81,
//       CHF: 0.47,
//     },
//   },
// ];

const CurrencyTable = () => {
  const [currencies, setCurrencies] = useState([]);
  const getAllCurrency = async () => {
    try {
      const currencyList = [
        "USD",
        "EUR",
        "INR",
        "AUD",
        "JPY",
        "CAD",
        "CHF",
        "NZD",
      ];
      const responses = await Promise.all(
        currencyList.map(async (currency) => {
          const response = await axiosInstance.get(
            `${ApiKey}/latest/${currency}`
          );
          const conversionRates = response.data.conversion_rates;

          return {
            name: currency,
            flag: `https://flagcdn.com/${currency
              .slice(0, 2)
              .toLowerCase()}.svg`,
            conversions: Object.fromEntries(
              currencyList
                .filter((c) => c !== currency)
                .map((c) => [
                  c,
                  parseFloat(conversionRates[c].toFixed(2)), // 2 decimal places
                ])
            ),
          };
        })
      );
      setCurrencies(responses);
      console.log(responses); 
      return responses; 
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };
  useEffect(() => {
    getAllCurrency();
  }, []);

  return (
    <div className="lg:w-10/12 container px-4 sm:px-6 md:px-12 overflow-hidden mx-auto">
      <h2 className="text-4xl font-bold md:pb-14 pb-6 md:pt-20 mt-10 mb-4 text-center">
        Top currencies
      </h2>

      {/* Scrollable Table Wrapper */}
      <div className="bg-white shadow-md rounded-lg p-6 overflow-x-auto">
        <table className="min-w-full bg-white">
          <thead>
            <tr>
              <th className="border-r border-b px-4 py-4">{""}</th>
              {currencies.map((currency, index) => (
                <th
                  key={index}
                  className="border-r border-b px-4 py-4 whitespace-nowrap"
                >
                  <img
                    src={currency?.flag}
                    alt={currency?.name}
                    className="inline-block w-6 h-4 mr-2"
                  />
                  {currency?.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currencies?.map((currency, index) => (
              <tr key={index} className="">
                <td className="border-r px-4 py-4 font-bold whitespace-nowrap">
                  <img
                    src={currency?.flag}
                    alt={currency?.name}
                    className="inline-block w-6 h-4 mr-2"
                  />
                  {currency?.name}
                </td>
                {currencies?.map((targetCurrency, idx) => (
                  <td key={idx} className="border-r px-4 py-4 text-center">
                    {currency?.name === targetCurrency?.name
                      ? "1"
                      : currency?.conversions[targetCurrency?.name] || "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex items-center md:flex-row flex-col justify-between gap-4 py-4">
        <p className="lg:w-8/12 w-full">
          <span className="font-bold"> Beware of bad exchange rates.</span>
          Banks and traditional providers often have extra costs, which they
          pass to you by marking up the exchange rate. Our smart tech means
          we’re more efficient – which means you get a great rate. Every time.
        </p>
        <button className="lg:w-4/12 w-full text-white border-2 border-[#60C90B] bg-primary py-2 rounded-primary px-4">
          Compare exchange rates
        </button>
      </div>
    </div>
  );
};

export default CurrencyTable;
